<template>
  <article class="popup error-merge">
    <img src="../../../assets/error_icon.svg" alt="">
    <h2 class="title">{{$t('errors.things.errorMergeThing')}}</h2>
    <button type="button"
            @click="closeAll"
            class="btn btn-transparent_dark">
      Ok
    </button>
    <close-btn></close-btn>
  </article>
</template>

<script>
  import closeBtn from '../closeBtn'
  import {popups} from "../../../mixins/popups";

  export default {
    name: 'errorMerge',
    mixins: [popups],
    components: {
      closeBtn
    }
  }
</script>

<style lang="scss" scoped>
  img {
    max-width: 100px;
    margin-bottom: 20px;
  }

  .error-merge {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    position: absolute;
    top: calc(50% - 318px / 2);
    left: calc(50% - 493px / 2);
  }

  .title {
    font-family: $msb;
    font-size: 20px;
    margin-bottom: 20px;
    line-height: 120%;
  }

  .thing {
    font-family: $mr;
    font-size: 16px;
    margin-bottom: 20px;
  }

  .btn-cont {
    display: flex;

    button {
      margin: 0 10px;
      width: 180px;
    }
  }
</style>
